import RequireUserMiddleware from 'middlewares/RequireUserMiddleware'
import LoadSessionMiddleware from 'middlewares/LoadSessionMiddleware'
import ForbidSubdomainMiddleware from 'middlewares/ForbidSubdomainMiddleware'
import RoutesEnum from 'enums/routes.enum'

export default [
    {
        path: '/company/create',
        name: RoutesEnum.COMPANY.CREATE,
        view: 'company/CreateCompany',
        middlewares: [RequireUserMiddleware, ForbidSubdomainMiddleware],
        meta: {
            layout: 'main',
            title: 'Kreiranje Kompanije | Bookeraj',
            description: 'Kreirajte svoju kompaniju na našoj platformi.',
        },
    },
    {
        path: '/company/my/:id/:tabType',
        name: RoutesEnum.COMPANY.MY_COMPANY,
        view: 'company/MyCompany',
        middlewares: [RequireUserMiddleware, ForbidSubdomainMiddleware],
        meta: {
            layout: 'main',
            title: 'Moja Kompanija | Bookeraj',
            description:
                'Saznajte više o našoj kompaniji, našoj misiji i vrednostima. Otkrijte naše proizvode, usluge i kako možemo da vam pomognemo.',
        },
    },
    {
        path: '/company/companies',
        name: RoutesEnum.COMPANY.MY_COMPANIES,
        view: 'company/MyCompanies',
        middlewares: [RequireUserMiddleware, ForbidSubdomainMiddleware],
        meta: {
            layout: 'main',
            title: 'Moje Kompanije | Bookeraj',
            description:
                'Pregledajte informacije o različitim kompanijama koje pripadaju našem portfoliju. Saznajte više o našim kompanijama, njihovim proizvodima i uslugama.',
        },
    },
    {
        path: '/company/:id/:companyType',
        name: RoutesEnum.COMPANY.PROFILE,
        view: 'company/CompanyProfile',
        middlewares: [LoadSessionMiddleware, ForbidSubdomainMiddleware],
        meta: {
            layout: 'main',
            title: 'Profil Kompanije | Bookeraj',
            description:
                'Pregledajte detalje o profilu kompanije, saznajte više o njenim uslugama, proizvodima i istoriji. Kontaktirajte nas za dodatne informacije.',
        },
    },
]
